import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import TemplateDetailAside from './TemplateDetailAside';
import TemplateDetailContent from './TemplateDetailContent';
import TemplateDetailHeader from './TemplateDetailHeader';
import { useParams } from 'react-router-dom';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { getFacilityDetails } from 'nursd-dashboard/api/facilityTable';
import { getTemplateDetails } from 'nursd-dashboard/api/jobTemplate';

const TemplateDetail = () => {
  const { templateId } = useParams();
  const { authToken } = useAuth();
  const [template, setTemplate] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const getTemplateDetail = async id => {
    await getTemplateDetails(authToken, id)
      .then(async res => {
        await getFacilityDetails(
          authToken,
          res?.jobPostingTableFacilityTableId
        ).then(re => {
          setTemplate({
            ...res,
            manager: re
          });
          setLoading(false);
        });
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (templateId) {
      getTemplateDetail(templateId);
    }
  }, [templateId]);

  return (
    <>
      {loading ? (
        <Card>
          <p className="m-2">Loading...</p>
        </Card>
      ) : (
        <>
          <TemplateDetailHeader template={template} />
          <Row className="g-3">
            <Col lg={8}>
              <TemplateDetailContent template={template} />
            </Col>
            <Col lg={4}>
              <TemplateDetailAside template={template} />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default TemplateDetail;
